import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import MixPanel from 'utils/mixpanelService';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { makeSelectAuth } from 'containers/Auth/selectors';
import {
  makeSelectAllowSignIn,
  makeSelectClientDetails,
} from 'containers/Main/selectors';
import { moveAnonymousAssessments } from 'containers/Assessment/actions';
import SurveyResultContext from '../SurveyResultContext';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  button: {
    padding: '12px 40px',
    borderRadius: 4,
    fontSize: '0.9375rem',
    fontFamily: 'MadaSemiBold',
    minWidth: 120,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}));

const GaugeSignUpButton = ({ assessment }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const allowSignIn = useSelector(makeSelectAllowSignIn());
  const auth = useSelector(makeSelectAuth());
  const clientDetails = useSelector(makeSelectClientDetails());
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const assessmentId = _get(assessment, 'sys.id', '');
  const assessmentName = _get(assessment, 'fields.name', '');
  const slug = _get(assessment, 'fields.slug', '');

  const { handleEmailResults } = useContext(SurveyResultContext);

  if (
    !allowSignIn ||
    (!auth.isEmpty &&
      _get(clientDetails, 'metadata.hideEmailMyResultsButton', false))
  )
    return null;

  const handleSaveResultsClick = () => {
    MixPanel.track('Assessment Results - Sign Up CTA - Clicked', {
      slug,
      assessmentName,
      assessmentId,
      page: window.location.pathname,
      path: 'assessment results',
    });
    dispatch(moveAnonymousAssessments());
  };

  const handleEmailResultsClick = () => {
    MixPanel.track('Assessment Results - Email Results - Clicked', {
      slug,
      assessmentName,
      assessmentId,
      page: window.location.pathname,
      path: 'assessment results',
      type: 'top cta',
    });
    handleEmailResults();
  };

  return (
    <Box className={classes.wrapper}>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={
          auth.isEmpty ? handleSaveResultsClick : handleEmailResultsClick
        }
      >
        {_get(assessmentResultsSiteCopy, [
          'pageCopy',
          auth.isEmpty ? 'signUpLabel' : 'emailResultsLabel',
        ])}
      </Button>
    </Box>
  );
};

export default GaugeSignUpButton;
